import type { AgentSettingsFormValues } from '../config/base.config'
import type { ConversationGoal } from '../types'
import { cleanConversationGoalsForExport } from './node-cleanup'

type ImportedAgentSettingsSource = {
  agentSettings?: AgentSettingsFormValues | null
  conversationGoals?: ConversationGoal[] | null
}

export const getImportedAgentSettings = (
  source: ImportedAgentSettingsSource,
): AgentSettingsFormValues | null => {
  const hasTopLevelConversationGoals = Object.hasOwn(source, 'conversationGoals')
  const importedConversationGoals = hasTopLevelConversationGoals
    ? cleanConversationGoalsForExport(source.conversationGoals)
    : source.agentSettings?.conversation_goals
      ? cleanConversationGoalsForExport(source.agentSettings.conversation_goals)
      : undefined

  if (!source.agentSettings && !hasTopLevelConversationGoals) return null

  return {
    ...(source.agentSettings ?? {}),
    ...(importedConversationGoals !== undefined
      ? { conversation_goals: importedConversationGoals }
      : {}),
  } as AgentSettingsFormValues
}
